import styled, {css} from 'styled-components';

import {IconContainer} from 'components/ui-kit/Icon/styled';
import {Pill} from 'components/ui-kit/Pills';
import {breakpoint, colors} from 'theme';

export const Root = styled.div`
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: baseline;
    flex: 1;

    .react-datepicker-wrapper {
        flex: 1;
        max-width: 160px;
        //margin-right: 20px;
    }
`;

export const StyledPill = styled(Pill)`
    margin-right: 10px;
    margin-top: 5px;
    width: 120px;

    @media (min-width: ${breakpoint.tablet}) {
        display: flex;
        justify-content: center;
    }

    @media (max-width: ${breakpoint.tablet}) {
        width: auto;
    }

    ${(p) =>
        !p.isActive &&
        css`
            color: ${colors.textMuted};
            border-bottom: 2px solid #e7e8ea;
        `}
`;

export const DateFilter = styled.div`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;

    p {
        display: none;
        font-size: 12px;
        line-height: 0;

        @media (min-width: ${breakpoint.tablet}) {
            display: block;
        }
    }

    ${IconContainer} {
        margin-left: 10px;
        margin-top: 7px;
        cursor: pointer;

        @media (min-width: ${breakpoint.tablet}) {
            margin-top: 0;
        }
    }
`;
